import React from 'react';
import { Navigation } from '../../../../global-functions';
import { ICartItemInfo } from '../../../../models/pro-sites';
import Modal, { IModalChildProps } from '../../../common/modal';
import { HEARING_AIDS_URL_PARAMS } from '../../../../models/constants';
import { Link } from 'react-router-dom';
import {
    FormattedMessage,
    FormattedNumber,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { useEffect } from 'react';

interface IMessageModal extends IModalChildProps {
    cartItems: ICartItemInfo[];
}

const ReorderMessageModal = ({ cartItems, onClose }: IMessageModal) => {
    const intl = useIntl();
    useEffect(() => {
        localStorage.setItem('reorder', 'true');
    }, []);
    return (
        <Modal>
            <>
                <div className="modal-header">
                    <h4
                        className="modal-title font-green"
                        style={{ display: 'inline' }}
                    >
                        <span className="fad fa-check" />

                        <FormattedMessage
                            id="Added_to_Cart"
                            defaultMessage="Added to Cart"
                        />
                    </h4>
                    <button
                        type="button"
                        className="close"
                        id="closeModalCancelModal"
                        data-dismiss="modal"
                        aria-label={intl.formatMessage({
                            id: 'Close',
                        })}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-header">
                    {cartItems.map((item, i) => {
                        return (
                            i <= 5 && (
                                <div className="row" key={i}>
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <button
                                                    className="btn-link"
                                                    onClick={() =>
                                                        Navigation.pushExternal(
                                                            item.url
                                                        )
                                                    }
                                                >
                                                    <img
                                                        src={item.imageUrl}
                                                        style={{
                                                            height: '100px',
                                                        }}
                                                        alt={item.description}
                                                    />
                                                </button>
                                            </div>
                                            <div className="col-sm-9">
                                                <p className="noSpacing">
                                                    {' '}
                                                    <button
                                                        className="btn-link noSpacing"
                                                        onClick={() =>
                                                            Navigation.pushExternal(
                                                                item.url
                                                            )
                                                        }
                                                    >
                                                        <FormattedMessage
                                                            id={
                                                                item.description
                                                            }
                                                            defaultMessage={
                                                                item.description
                                                            }
                                                        />
                                                    </button>
                                                </p>
                                                {item.orderType && (
                                                    <p className="noSpacing">
                                                        <FormattedMessage
                                                            id={item.orderType}
                                                            defaultMessage={
                                                                item.orderType
                                                            }
                                                        />
                                                    </p>
                                                )}
                                                {item.quantity && (
                                                    <p>
                                                        <FormattedMessage
                                                            id="Quantity"
                                                            defaultMessage="Quantity"
                                                        />
                                                        {': '}
                                                        <FormattedNumber
                                                            value={
                                                                item.quantity
                                                            }
                                                        />
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
                <div className="modal-footer">
                    <Link
                        to={'/estore/cart'}
                        className="btn btn-default pull-left"
                    >
                        <FormattedMessage
                            id="View_Cart"
                            defaultMessage="View Cart"
                        />
                    </Link>
                    <span className="pull-right">
                        <Link
                            to={
                                '/estore/product-list?' +
                                HEARING_AIDS_URL_PARAMS
                            }
                            className="btn btn-default"
                        >
                            <FormattedMessage
                                id="Continue_Shopping"
                                defaultMessage="Continue Shopping"
                            />
                        </Link>
                        <button
                            className="btn btn-info"
                            onClick={() => {
                                Navigation.pushExternal('/estore/checkout');
                            }}
                        >
                            <FormattedMessage
                                id="Proceed_to_Checkout"
                                defaultMessage="Proceed to Checkout"
                            />
                        </button>
                    </span>
                </div>
            </>
        </Modal>
    );
};

export default ReorderMessageModal;
